._1kagu2y0 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: var(--_1qu8za24);
  margin: -16px 70px 24px 0;
}
._1kagu2y1 {
  display: flex;
  gap: 8px;
  margin-top: 48px;
}
._1kagu2y1 > button {
  flex: 1 1 0;
}
._1kagu2y2 {
  background: var(--_1qu8za2d);
  border-radius: 64px;
  padding-left: 12px;
  padding-right: 4px;
  height: 32px;
}
._1kagu2y3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
._1kagu2y4 {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 16px;
}
._1kagu2y5 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  color: var(--_1qu8za24);
}
._1kagu2y6 {
  display: flex;
  flex-direction: column;
  max-height: 320px;
  overflow-y: auto;
  border: 1px solid var(--_1qu8za21);
  border-radius: 12px;
}
._1kagu2y7 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  cursor: pointer;
}
._1kagu2y7:hover {
  background: var(--_1qu8za2d);
}
._1kagu2y8 {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
._1kagu2y9 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
._1kagu2ya {
  font-weight: 400;
  font-size: 12px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: var(--_1qu8za24);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}